class MFRZipCode {
  constructor(index, element) {
    this.$index = index
    this.$element = $(element)

    this.selectors = {
      zipcode_form: '#zipcode-form',
      zipcode_input: '#zipcode-input',
    }

    this.init()
  }

  init() {
    this.$element.find(this.selectors.zipcode_form).submit(this.searchZipCode.bind(this))
  }

  searchZipCode(event) {
    event.preventDefault()
    let zipcodeValue = this.$element.find(this.selectors.zipcode_input).val()
    window.location.replace(`/pages/store-locator?MM=panel2&ZIP=${zipcodeValue}`)
  }
}